// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.invisible[data-v-fbcf9828]{\r\n\topacity: 0;\r\n\tpointer-events: none;\n}\n.w-link[data-v-fbcf9828]{ padding: 2px 4px; line-height: 28px;\n}\n.selected[data-v-fbcf9828] {\r\n\tbackground-color: var(--main-blue-1);\r\n\tpadding: 2px 4px; border-radius: 2px; border:1px solid var(--main-blue-3); color:#fff;\n}\r\n\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
